import { createContext,useContext } from "react";
import { useNavigate,useLocation } from "react-location";

type NavigationContextType = {
    goToLoginPage : (replace:boolean) => void,
    goToDashboard : (replace:boolean) => void,
    goToEntryCompletionPage : (replace:boolean) => void,
    goToRegisterPage : (replace:boolean) => void,
    goToRandomizePage : (replace:boolean) => void,
    goToDownloadPage : (replace:boolean) => void,
    goToExportPage : (replace:boolean) => void,
    goToSettingsPage : (replace:boolean) => void,
    goToPurchasePage : (replace:boolean) => void,
    goToCheckoutPage : (replace:boolean) => void,
    goToImportICalPage : (replace:boolean) => void,
    goToForgotPasswordPage : (replace:boolean) => void,
    goBack : () => void,
    goToPage(path:string,replace:boolean):void,
    
}

const NavigationContext = createContext<NavigationContextType>({
       goToLoginPage(replace: boolean): void {},
       goToDashboard(replace: boolean): void {},
       goToEntryCompletionPage(replace: boolean): void {},
       goToRegisterPage(replace: boolean): void {},
         goToRandomizePage(replace: boolean): void {},
         goToDownloadPage(replace: boolean): void {},
            goToExportPage(replace: boolean): void {},
            goToSettingsPage(replace: boolean): void {},
            goToPurchasePage(replace: boolean): void {},
            goToCheckoutPage(replace: boolean): void {},
            goToImportICalPage(replace: boolean): void {},
            goToForgotPasswordPage(replace: boolean): void {},
            goBack(): void {},
        goToPage(path: string, replace: boolean): void {},
});




export function NavigationProvider({ children }: { children: React.ReactNode }) {

        // const [username, setUsername] = useState("");
        // const [password, setPassword] = useState("");
        const navigate = useNavigate(); 

        const location = useLocation()


   


    function goToLoginPage(replace: boolean): void {
        navigate({ to: "/login", replace: replace });
    }
    function goToDashboard(replace: boolean): void {
        navigate({ to: "/dashboard", replace: replace });
    }
    function goToRegisterPage(replace: boolean): void {
        navigate({ to: "/register", replace: replace });
    }

    function goToRandomizePage(replace: boolean): void {
        navigate({ to: "/randomize", replace: replace });
    }

    function goToEntryCompletionPage(replace: boolean): void {
        navigate({ to: "/entryCompletion", replace: replace});
    }
    function goToDownloadPage(replace: boolean): void {
        navigate({ to: "/download", replace: replace});
    }
    function goToExportPage(replace: boolean): void {
        navigate({ to: "/export", replace: replace});
    }

    function goToSettingsPage(replace: boolean): void {
        navigate({ to: "/settings", replace: replace});
    }

    function goToPurchasePage(replace: boolean): void {
        navigate({ to: "/purchase", replace: replace});
    }

    function goToThankYouPage(replace: boolean): void {
        navigate({ to: "/thank-you", replace: replace});
    }

    function goToImportICalPage(replace: boolean): void {
        navigate({ to: "/importICal", replace: replace});
    }

    function goToForgotPasswordPage(replace: boolean): void {
        navigate({ to: "/forgot", replace: replace});
    }

    function goBack(): void {
        navigate({ to: location.history.back() });
    }

    function goToPage(path: string, replace: boolean): void {
        navigate({ to: path, replace: replace });
    }

        const navigationContext = {
               
               goToLoginPage,
              goToDashboard,
               goToRegisterPage,
               goToEntryCompletionPage,
               goToRandomizePage,
               goToDownloadPage,
               goToExportPage,
               goToSettingsPage,
                goToPurchasePage,
                goToCheckoutPage: goToThankYouPage,
                goToImportICalPage,
                goToForgotPasswordPage,
               goBack,
               goToPage
        };


    return (
        <NavigationContext.Provider value={navigationContext}>


            {children}
        </NavigationContext.Provider>
    );
}

export function useNavigationContext() {return useContext(NavigationContext);};
